module.exports = __webpack_public_path__ + "../resources/img/ic_water_drop_weather.ec0e9161.svg";